import Dialog from '@/js/components/Dialog'
import { fetchJson, formErrors } from '@/js/services/utils'

// fixme autofocus first input

export default class DialogLogin extends Dialog {
    backdropClose = false

    render() {
        if (this.el) {
            return
        }

        const template = document.getElementById(`dialog-${this.name}`)

        if (!template) {
            console.error('Template not found')
            return
        }

        const dialog = template.content.firstElementChild

        this.refs = {
            form: dialog.querySelector('form'),
            submit: dialog.querySelector('[type=submit]'),
        }

        if (this.refs.form) {
            this.#initForm()
        }

        super.render(dialog)
    }

    #initForm() {
        this.refs.form.addEventListener('submit', this.#onFormSubmit.bind(this))
        this.refs.form.addEventListener('input', this.#onFormInput.bind(this))
    }

    #onFormInput(e) {
        const errorElement = e.target.parentElement.querySelector('.form-control__hint.error')

        if (errorElement) {
            errorElement.remove()
        }
    }

    async #onFormSubmit(e) {
        e.preventDefault()

        this.refs.submit.disabled = true
        this.refs.form.querySelectorAll('.form-control__hint.error').forEach(el => {
            el.remove()
        })

        try {
            const response = await fetchJson(this.refs.form.action, {
                method: this.refs.form.method,
                body: new FormData(this.refs.form),
            })

            if (this.onSubmitSuccess) {
                this.onSubmitSuccess(response)
            }
        } catch (error) {
            formErrors(this.refs.form, error)
        }

        this.refs.submit.disabled = false
    }
}
